// extracted by mini-css-extract-plugin
export default {"info-container":"DHDo78nQB_T4easbaHD4"};